(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["restock-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solstice-restock-request')) {
    customElements.define('solstice-restock-request', class extends HTMLElement {
      connectedCallback() {
        this.productForm = this.closest('[data-product-handle]')?.querySelector('[data-product-form]');
        this.details = this.querySelector('details');
        this.contactForm = this.querySelector('form');
        this.data = JSON.parse(this.querySelector('[data-restock-variants]').textContent);
        this.onChange = () => this.updateVariant();
        this.onSubmit = (event) => {
          event.stopPropagation();
          const variant = this.updateVariant();
          if (!variant || variant.available) event.preventDefault();
        };
        this.productForm?.addEventListener('change', this.onChange);
        this.contactForm?.addEventListener('submit', this.onSubmit);
        this.updateVariant();
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener('change', this.onChange);
        this.contactForm?.removeEventListener('submit', this.onSubmit);
      }
      selectedVariant() {
        const selectedOptions = [];
        this.productForm?.querySelectorAll('[data-index]').forEach((input) => {
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
          const position = Number(input.dataset.index.replace('option', '')) - 1;
          if (Number.isInteger(position) && position >= 0) selectedOptions[position] = input.value;
        });
        if (selectedOptions.length) {
          return this.data.variants.find((variant) => variant.options.length === selectedOptions.length && variant.options.every((option, index) => option === selectedOptions[index]));
        }
        return this.data.variants.find((variant) => String(variant.id) === this.dataset.initialVariant);
      }
      updateVariant() {
        const variant = this.selectedVariant();
        if (!this.details) return variant;
        const available = !variant || variant.available;
        if (!this.querySelector('[data-restock-feedback]')) this.details.hidden = available;
        this.querySelectorAll('[name^="contact["], button[type="submit"]').forEach((input) => { input.disabled = available; });
        if (!variant) return variant;
        const url = new URL(this.dataset.productUrl);
        url.searchParams.set('variant', variant.id);
        this.querySelector('[data-restock-selection]').textContent = `${this.dataset.productTitle} — ${variant.title}`;
        this.querySelector('[data-restock-title]').value = variant.title;
        this.querySelector('[data-restock-id]').value = variant.id;
        this.querySelector('[data-restock-sku]').value = variant.sku || '';
        this.querySelector('[data-restock-url]').value = url.href;
        this.querySelector('[data-restock-body]').value = `Solstice restock request\nProduct: ${this.dataset.productTitle}\nVariant: ${variant.title}\nProduct ID: ${this.data.productId}\nVariant ID: ${variant.id}\nSKU: ${variant.sku || ''}\nProduct URL: ${url.href}\nPlease email me about this piece if it is restocked. This is not a newsletter subscription.`;
        return variant;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
